import styled from 'styled-components';
import { Content } from 'styles/styles';

export const PayoutContent = styled(Content)`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AmountCardsRow = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;
